import React from 'react';

const QuestionCard = ({ question, selectedOption, onAnswer }) => {
  if (!question) return null;

  // Pemetaan trait ke label yang lebih mudah dibaca
  const traitLabels = {
    'structure': 'Terstruktur',
    'flexibility': 'Fleksibel',
    'introvert': 'Introvert',
    'extrovert': 'Ekstrovert',
    'practical': 'Praktis',
    'conceptual': 'Konseptual',
    'risk': 'Pengambil Risiko',
    'caution': 'Hati-hati',
    'independent': 'Mandiri',
    'collaborative': 'Kolaboratif'
  };

  // Pemetaan trait ke warna untuk label
  const traitColors = {
    'structure': 'bg-blue-100 text-blue-800',
    'flexibility': 'bg-blue-100 text-blue-800',
    'introvert': 'bg-purple-100 text-purple-800',
    'extrovert': 'bg-purple-100 text-purple-800',
    'practical': 'bg-green-100 text-green-800',
    'conceptual': 'bg-green-100 text-green-800',
    'risk': 'bg-orange-100 text-orange-800',
    'caution': 'bg-orange-100 text-orange-800',
    'independent': 'bg-indigo-100 text-indigo-800',
    'collaborative': 'bg-indigo-100 text-indigo-800'
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mb-6 transition-all duration-300">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-800 mb-3">{`Soal ${question.id}`}</h2>
        <p className="text-gray-700 text-lg">
          Pilih salah satu dari dua pernyataan berikut yang lebih sesuai dengan pengalaman pribadi Anda:
        </p>
      </div>

      <div className="space-y-4">
        {question.options.map((option, index) => {
          // Mendapatkan trait dari metadata jika tersedia
          const trait = question.metadata && question.metadata[index] ? 
                         question.metadata[index].dimensionTrait : null;
          
          return (
            <button
              key={index}
              onClick={() => onAnswer(question.id, index)}
              className={`w-full text-left p-5 rounded-lg border-2 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400 
                ${selectedOption === index 
                  ? 'bg-blue-50 border-blue-500 shadow-md' 
                  : 'bg-white border-gray-200 hover:bg-gray-50 hover:border-gray-300'}`}
            >
              <div className="flex items-start">
                <div className={`flex-shrink-0 w-6 h-6 rounded-full border-2 mr-3 flex items-center justify-center
                  ${selectedOption === index ? 'bg-blue-500 border-blue-500' : 'border-gray-400'}`}
                >
                  {selectedOption === index && (
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
                <div className="w-full">
                  <p className={`text-base ${selectedOption === index ? 'font-medium text-blue-800' : 'text-gray-700'}`}>
                    {option}
                  </p>
                  
                  {/* Menampilkan label trait jika tersedia */}
                  {trait && (
                    <div className="mt-2 flex justify-end">
                      <span className={`inline-block px-2 py-1 text-xs font-medium rounded-full ${traitColors[trait]}`}>
                        {traitLabels[trait]}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionCard;